import * as React from "react";
const SvgFiRrCv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m12.76 10.469-1.072-5.253a.8.8 0 0 1 1.568-.32l1.072 5.253a.7.7 0 0 0 .05.159 1 1 0 0 0 .057-.188l1.053-5.222a.8.8 0 1 1 1.568.316l-1.051 5.211c-.126.647-.609 1.575-1.628 1.575s-1.51-.97-1.618-1.531zM8.5 5.6a.9.9 0 0 1 .863.645c.024.081.027.755.833.755s.815-.699.804-.796A2.517 2.517 0 0 0 8.5 4 2.5 2.5 0 0 0 6 6.5v3A2.5 2.5 0 0 0 8.5 12c1.278 0 2.35-.958 2.5-2.196.012-.1-.032-.804-.799-.804s-.813.669-.835.747A.901.901 0 0 1 7.6 9.5v-3c0-.496.404-.9.9-.9M22 5v8.515a6.96 6.96 0 0 1-2.05 4.95l-3.486 3.484A6.95 6.95 0 0 1 11.514 24H6.999c-2.757 0-5-2.243-5-5V5A5.007 5.007 0 0 1 7 0h10c2.757 0 5 2.243 5 5M11.515 22c.165 0 .323-.032.485-.047V17c0-1.654 1.346-3 3-3h4.953c.016-.162.047-.321.047-.485V5c0-1.654-1.346-3-3-3H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3zm7.021-4.949A5 5 0 0 0 19.317 16h-4.316c-.551 0-1 .448-1 1v4.316a5 5 0 0 0 1.05-.781z"
    />
  </svg>
);
export default SvgFiRrCv;
